/* eslint-disable max-len */

import React from 'react'

import { DiscountType } from './types'
import {
  darkenByModifier,
  Hex
} from 'public/components/default_template/online_ordering/item_tags/tagColorUtils'

export const TagIllustration = ({
  color,
  discountType
}: {
  color: string
  discountType: DiscountType
}) => {
  const secondaryColor = darkenByModifier(color as Hex, 12)
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='120'
      height='120'
      viewBox='0 0 120 120'
      fill='none'
      data-testid='tag-illustration'
    >
      <path
        d='M41.0231 50.9444C40.5546 49.1959 40.8675 47.3301 41.8809 45.8301L53.8118 28.1712C55.5533 25.5937 58.9257 24.6901 61.7226 26.0516L80.8845 35.3792C82.5121 36.1714 83.716 37.6308 84.1845 39.3793L96.1059 83.8704C96.9989 87.2031 95.0211 90.6287 91.6885 91.5217L60.5957 99.853C57.263 100.746 53.8374 98.7682 52.9444 95.4355L41.0231 50.9444Z'
        fill={secondaryColor}
      />
      <path
        d='M32.5696 35.9499C32.915 34.1729 34.0142 32.6331 35.5826 31.7292L54.0472 21.0877C56.7423 19.5345 60.1695 20.2006 62.0865 22.6504L75.2202 39.434C76.3357 40.8596 76.7781 42.699 76.4327 44.476L67.6439 89.6903C66.9856 93.0772 63.7063 95.2891 60.3195 94.6308L28.7213 88.4887C25.3344 87.8304 23.1225 84.5511 23.7809 81.1642L32.5696 35.9499Z'
        fill={color}
      />
      {discountType === DiscountType.PERCENT ? (
        <TagPercentSign />
      ) : (
        <TagDollarSign />
      )}
      <g opacity='0.75'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M98.5601 15.178V19.866L100.343 15.5359C100.38 15.4448 100.484 15.4021 100.576 15.4391C100.667 15.4761 100.709 15.5801 100.672 15.6712L98.8861 20.0084L102.186 16.6891C102.256 16.6193 102.369 16.6193 102.438 16.6891C102.508 16.7588 102.508 16.8713 102.438 16.9411L99.1409 20.2577L103.448 18.4632C103.538 18.4247 103.643 18.4688 103.68 18.5586C103.719 18.6497 103.674 18.7537 103.585 18.7907L99.2716 20.5877H103.939C104.037 20.5877 104.117 20.6675 104.117 20.7657C104.117 20.864 104.037 20.9437 103.939 20.9437H99.2705L103.584 22.7409C103.675 22.7794 103.718 22.8833 103.679 22.973C103.651 23.0414 103.585 23.0827 103.516 23.0827C103.493 23.0827 103.47 23.0784 103.447 23.0684L99.1373 21.2727L102.437 24.5914C102.507 24.6612 102.505 24.7737 102.437 24.8434C102.403 24.8776 102.357 24.8947 102.312 24.8947V24.8961C102.266 24.8961 102.22 24.879 102.185 24.8434L98.888 21.5275L100.672 25.8602C100.709 25.9513 100.667 26.0553 100.576 26.0923C100.553 26.1007 100.531 26.105 100.508 26.1051C100.438 26.1048 100.372 26.0636 100.343 25.9954L98.5601 21.6654V26.3421C98.5601 26.4403 98.4803 26.5201 98.3821 26.5201C98.2838 26.5201 98.2041 26.4403 98.2041 26.3421V21.6646L96.4204 25.9954C96.392 26.0636 96.3254 26.1048 96.2559 26.1051C96.2333 26.105 96.2108 26.1007 96.1882 26.0923C96.0971 26.0553 96.0544 25.9513 96.0914 25.8602L97.875 21.5296L94.5798 24.844C94.5456 24.8796 94.4986 24.8967 94.453 24.8967V24.8952C94.4074 24.8952 94.3619 24.8781 94.3277 24.844C94.2579 24.7742 94.2579 24.6617 94.3277 24.5919L97.6284 21.2721L93.3173 23.0682C93.2945 23.0782 93.2717 23.0825 93.249 23.0825C93.1792 23.0825 93.1137 23.0412 93.0852 22.9728C93.0467 22.8817 93.0909 22.7777 93.1806 22.7407L97.4936 20.9437H92.8245C92.7262 20.9437 92.6465 20.864 92.6465 20.7657C92.6465 20.6675 92.7262 20.5877 92.8245 20.5877H97.4935L93.1808 18.7909C93.0897 18.7524 93.0469 18.6485 93.0854 18.5588C93.1224 18.4676 93.2278 18.4249 93.3175 18.4633L97.6292 20.2598L94.3272 16.9386C94.2574 16.8688 94.2588 16.7563 94.3272 16.6866C94.3969 16.6168 94.5094 16.6182 94.5792 16.6866L97.8748 20.0012L96.0914 15.6712C96.0544 15.5801 96.0971 15.4761 96.1882 15.4391C96.2794 15.4021 96.3833 15.4448 96.4204 15.5359L98.2041 19.8668V15.178C98.2041 15.0797 98.2838 15 98.3821 15C98.4803 15 98.5601 15.0797 98.5601 15.178Z'
          fill={color}
        />
      </g>
      <g clipPath='url(#clip0_200_49)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.9179 103.728C21.941 103.736 21.9642 103.739 21.9856 103.739V103.738C22.0715 103.738 22.1507 103.685 22.1804 103.599L23.4251 99.9804C23.4614 99.8731 23.4036 99.7542 23.2963 99.7179C23.189 99.6816 23.0702 99.7393 23.0339 99.8466L21.7892 103.465C21.7529 103.572 21.8106 103.691 21.9179 103.728ZM19.8999 103.741C19.9346 103.814 20.0089 103.857 20.0848 103.857C20.1162 103.857 20.1459 103.85 20.1756 103.835C20.278 103.786 20.3192 103.662 20.2697 103.559L18.5909 100.121C18.5413 100.019 18.4175 99.9772 18.3152 100.027C18.2128 100.076 18.1716 100.2 18.2211 100.302L19.8999 103.741ZM18.8258 105.283C18.8043 105.283 18.7812 105.28 18.7581 105.272L15.1396 104.027C15.0323 103.991 14.9745 103.872 15.0109 103.765C15.0472 103.657 15.166 103.6 15.2733 103.636L18.8918 104.881C18.9991 104.917 19.0569 105.036 19.0206 105.143C18.9909 105.229 18.9116 105.282 18.8258 105.282V105.283ZM15.3197 108.747C15.3544 108.819 15.4287 108.862 15.5046 108.862C15.536 108.862 15.5657 108.856 15.5954 108.841L19.034 107.162C19.1363 107.112 19.1776 106.989 19.1281 106.886C19.0785 106.785 18.9547 106.743 18.8524 106.792L15.4138 108.471C15.3115 108.52 15.2702 108.644 15.3197 108.747ZM19.1243 112.061C19.1028 112.061 19.0797 112.058 19.0566 112.05C18.9493 112.014 18.8915 111.895 18.9278 111.787L20.1725 108.169C20.2089 108.062 20.3277 108.004 20.435 108.04C20.5423 108.076 20.6001 108.195 20.5638 108.303L19.3191 111.921C19.2894 112.007 19.2101 112.06 19.1243 112.06V112.061ZM23.7613 111.647C23.7959 111.72 23.8702 111.763 23.9462 111.763C23.9775 111.763 24.0072 111.756 24.0369 111.741C24.1393 111.692 24.1806 111.568 24.131 111.466L22.4522 108.027C22.4027 107.925 22.2789 107.883 22.1765 107.933C22.0742 107.983 22.0329 108.106 22.0824 108.209L23.7613 111.647ZM27.1471 108.143C27.1256 108.143 27.1026 108.139 27.0794 108.131L23.4609 106.886C23.3536 106.85 23.2958 106.731 23.3321 106.624C23.3685 106.517 23.4873 106.459 23.5946 106.495L27.2131 107.74C27.3204 107.776 27.3782 107.895 27.3419 108.002C27.3122 108.088 27.2329 108.141 27.1471 108.141V108.143ZM23.227 104.884C23.2616 104.956 23.3359 104.999 23.4118 104.999C23.4432 104.999 23.4729 104.993 23.5026 104.978L26.9412 103.299C27.0436 103.249 27.0848 103.126 27.0353 103.023C26.9858 102.921 26.862 102.88 26.7596 102.929L23.321 104.608C23.2187 104.657 23.1774 104.781 23.227 104.884Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_200_49'>
          <rect
            width='14.1176'
            height='14.1176'
            fill='white'
            transform='translate(14.1172 98.8242)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const StickerIllustration = ({
  color,
  discountType
}: {
  color: string
  discountType: DiscountType
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='120'
    height='120'
    viewBox='0 0 120 120'
    fill='none'
    data-testid='sticker-illustration'
  >
    <path
      d='M54.3183 21.7969C57.1433 17.9782 62.8558 17.9782 65.6808 21.7969C67.6381 24.4428 71.1627 25.3872 74.1807 24.0745C78.5366 22.1799 83.4838 25.0362 84.021 29.7557C84.3931 33.0257 86.9733 35.606 90.2433 35.9781C94.9629 36.5153 97.8192 41.4625 95.9246 45.8183C94.6119 48.8363 95.5563 52.361 98.2022 54.3183C102.021 57.1433 102.021 62.8558 98.2022 65.6808C95.5563 67.6381 94.6119 71.1627 95.9246 74.1807C97.8192 78.5366 94.9629 83.4838 90.2433 84.021C86.9733 84.3931 84.3931 86.9733 84.021 90.2433C83.4838 94.9629 78.5366 97.8192 74.1807 95.9246C71.1627 94.6119 67.6381 95.5563 65.6808 98.2022C62.8558 102.021 57.1433 102.021 54.3183 98.2022C52.361 95.5563 48.8363 94.6119 45.8183 95.9246C41.4625 97.8192 36.5153 94.9629 35.9781 90.2433C35.606 86.9733 33.0257 84.3931 29.7557 84.021C25.0362 83.4838 22.1799 78.5366 24.0745 74.1807C25.3872 71.1627 24.4428 67.6381 21.7969 65.6808C17.9782 62.8558 17.9782 57.1433 21.7969 54.3183C24.4428 52.361 25.3872 48.8363 24.0745 45.8183C22.1799 41.4625 25.0362 36.5153 29.7557 35.9781C33.0257 35.606 35.606 33.0257 35.9781 29.7557C36.5153 25.0362 41.4625 22.1799 45.8183 24.0745C48.8363 25.3872 52.361 24.4428 54.3183 21.7969Z'
      fill={color}
    />
    {discountType === DiscountType.PERCENT ? (
      <StickerPercentSign />
    ) : (
      <StickerDollarSign />
    )}
    <g opacity='0.75'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.7066 15.8972V11.2073C18.7066 11.109 18.6269 11.0293 18.5286 11.0293C18.4303 11.0293 18.3506 11.109 18.3506 11.2073V15.898L16.5669 11.5672C16.5299 11.476 16.4259 11.4333 16.3348 11.4703C16.2436 11.5074 16.2009 11.6113 16.2379 11.7025L18.0213 16.0325L14.7257 12.7178C14.656 12.6495 14.5435 12.648 14.4737 12.7178C14.4053 12.7876 14.4039 12.9001 14.4737 12.9699L17.7724 16.2877L13.464 14.4926C13.3743 14.4542 13.2689 14.4969 13.2319 14.5881C13.1935 14.6778 13.2362 14.7817 13.3273 14.8202L17.6403 16.6171H12.971C12.8727 16.6171 12.793 16.6969 12.793 16.7951C12.793 16.8934 12.8727 16.9732 12.971 16.9732H17.6398L13.3271 18.77C13.2374 18.807 13.1933 18.911 13.2317 19.0021C13.2602 19.0705 13.3257 19.1118 13.3955 19.1118C13.4183 19.1118 13.441 19.1075 13.4638 19.0975L17.7749 17.3013L14.4742 20.6212C14.4044 20.691 14.4044 20.8035 14.4742 20.8733C14.5084 20.9074 14.554 20.9245 14.5995 20.9245V20.926C14.6451 20.926 14.6921 20.9089 14.7263 20.8733L18.0229 17.5575L16.2379 21.8914C16.2009 21.9825 16.2436 22.0865 16.3348 22.1235C16.3573 22.132 16.3799 22.1363 16.4024 22.1363C16.4719 22.1361 16.5385 22.0948 16.5669 22.0267L18.3506 17.6958V22.3714C18.3506 22.4696 18.4303 22.5494 18.5286 22.5494C18.6269 22.5494 18.7066 22.4696 18.7066 22.3714V17.6966L20.49 22.0267C20.5184 22.0948 20.585 22.1361 20.6545 22.1363C20.677 22.1363 20.6996 22.132 20.7221 22.1235C20.8132 22.0865 20.856 21.9825 20.8189 21.8914L19.0331 17.5554L22.3313 20.8727C22.3669 20.9083 22.4125 20.9254 22.458 20.9254V20.924C22.5036 20.924 22.5492 20.9069 22.5834 20.8727C22.6517 20.803 22.6531 20.6905 22.5834 20.6207L19.2839 17.302L23.5938 19.0977C23.6166 19.1077 23.6393 19.112 23.6621 19.112C23.7319 19.112 23.7974 19.0707 23.8259 19.0023C23.8643 18.9126 23.8216 18.8087 23.7305 18.7702L19.4173 16.9732H24.0856C24.1838 16.9732 24.2636 16.8934 24.2636 16.7951C24.2636 16.6969 24.1838 16.6171 24.0856 16.6171H19.4178L23.7313 14.82C23.821 14.783 23.8651 14.679 23.8267 14.5879C23.7896 14.4981 23.6843 14.454 23.5946 14.4924L19.2874 16.287L22.5849 12.9704C22.6546 12.9006 22.6546 12.7881 22.5849 12.7183C22.5151 12.6486 22.4026 12.6486 22.3328 12.7183L19.034 16.0363L20.8189 11.7025C20.856 11.6113 20.8132 11.5074 20.7221 11.4703C20.631 11.4333 20.527 11.476 20.49 11.5672L18.7066 15.8972Z'
        fill={color}
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M102.212 101.079C102.235 101.087 102.258 101.091 102.28 101.091V101.089C102.365 101.089 102.445 101.036 102.474 100.95L103.719 97.3319C103.755 97.2246 103.698 97.1058 103.59 97.0695C103.483 97.0331 103.364 97.0909 103.328 97.1982L102.083 100.817C102.047 100.924 102.105 101.043 102.212 101.079ZM100.194 101.093C100.229 101.165 100.303 101.208 100.379 101.208C100.41 101.208 100.44 101.202 100.47 101.187C100.572 101.137 100.613 101.013 100.564 100.911L98.8848 97.4724C98.8353 97.3701 98.7115 97.3288 98.6091 97.3783C98.5068 97.4278 98.4655 97.5517 98.515 97.654L100.194 101.093ZM99.1197 102.635C99.0983 102.635 99.0752 102.632 99.0521 102.623L95.4336 101.379C95.3263 101.342 95.2685 101.223 95.3048 101.116C95.3411 101.009 95.46 100.951 95.5673 100.987L99.1858 102.232C99.2931 102.268 99.3508 102.387 99.3145 102.495C99.2848 102.58 99.2056 102.633 99.1197 102.633V102.635ZM95.6137 106.098C95.6483 106.171 95.7226 106.214 95.7986 106.214C95.8299 106.214 95.8596 106.207 95.8894 106.192L99.3279 104.513C99.4303 104.464 99.4715 104.34 99.422 104.238C99.3725 104.137 99.2487 104.094 99.1463 104.144L95.7078 105.823C95.6054 105.872 95.5642 105.996 95.6137 106.098ZM99.4182 109.413C99.3968 109.413 99.3737 109.41 99.3506 109.401C99.2433 109.365 99.1855 109.246 99.2218 109.139L100.466 105.52C100.503 105.413 100.622 105.355 100.729 105.392C100.836 105.428 100.894 105.547 100.858 105.654L99.613 109.273C99.5833 109.359 99.5041 109.411 99.4182 109.411V109.413ZM104.055 108.999C104.09 109.071 104.164 109.114 104.24 109.114C104.271 109.114 104.301 109.108 104.331 109.093C104.433 109.043 104.475 108.92 104.425 108.817L102.746 105.379C102.697 105.276 102.573 105.235 102.47 105.285C102.368 105.334 102.327 105.458 102.376 105.56L104.055 108.999ZM107.441 105.494C107.42 105.494 107.397 105.491 107.373 105.483L103.755 104.238C103.648 104.202 103.59 104.083 103.626 103.976C103.662 103.868 103.781 103.81 103.889 103.847L107.507 105.091C107.614 105.128 107.672 105.247 107.636 105.354C107.606 105.44 107.527 105.493 107.441 105.493V105.494ZM103.521 102.235C103.556 102.308 103.63 102.351 103.706 102.351C103.737 102.351 103.767 102.344 103.797 102.329L107.235 100.65C107.338 100.601 107.379 100.477 107.329 100.375C107.28 100.272 107.156 100.231 107.054 100.281L103.615 101.96C103.513 102.009 103.471 102.133 103.521 102.235Z'
      fill={color}
    />
  </svg>
)

/**
 * Fill overrides for the parts of the bag that are derived from `color` by
 * default. Omitted entries keep the derived two-tone palette, so a caller that
 * follows the merchant theme passes `color` alone.
 */
export type FreeDeliveryIllustrationPalette = {
  /** The bag's folded-over flap. Defaults to `color`. */
  flap?: string
  /** The rule on the white label. Defaults to a darkened `color`. */
  label?: string
  /** The bag's shaded left face. Defaults to a darkened `color`. */
  panel?: string
}

export const FreeDeliveryIllustration = ({
  color,
  palette,
  altText
}: {
  color: string
  palette?: FreeDeliveryIllustrationPalette
  altText?: string
}) => {
  const secondaryColor = darkenByModifier(color as Hex, 50)
  const flapColor = palette?.flap ?? color
  // The label rule and the left face share the derived tone by default, but a
  // fixed palette can pull them apart.
  const labelColor = palette?.label ?? secondaryColor
  const panelColor = palette?.panel ?? secondaryColor
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='120'
      height='120'
      viewBox='0 0 120 120'
      fill='none'
      data-testid='free-delivery-illustration'
    >
      {altText && <title>{altText}</title>}
      <g opacity='0.75'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M98.5601 15.178V19.866L100.343 15.5359C100.38 15.4448 100.484 15.4021 100.576 15.4391C100.667 15.4761 100.709 15.5801 100.672 15.6712L98.8861 20.0084L102.186 16.6891C102.256 16.6193 102.369 16.6193 102.438 16.6891C102.508 16.7588 102.508 16.8713 102.438 16.9411L99.1409 20.2577L103.448 18.4632C103.538 18.4247 103.643 18.4688 103.68 18.5586C103.719 18.6497 103.674 18.7537 103.585 18.7907L99.2716 20.5877H103.939C104.037 20.5877 104.117 20.6675 104.117 20.7657C104.117 20.864 104.037 20.9437 103.939 20.9437H99.2705L103.584 22.7409C103.675 22.7794 103.718 22.8833 103.679 22.973C103.651 23.0414 103.585 23.0827 103.516 23.0827C103.493 23.0827 103.47 23.0784 103.447 23.0684L99.1373 21.2727L102.437 24.5914C102.507 24.6612 102.505 24.7737 102.437 24.8434C102.403 24.8776 102.357 24.8947 102.312 24.8947V24.8961C102.266 24.8961 102.22 24.879 102.185 24.8434L98.888 21.5275L100.672 25.8602C100.709 25.9513 100.667 26.0553 100.576 26.0923C100.553 26.1007 100.531 26.105 100.508 26.1051C100.438 26.1048 100.372 26.0636 100.343 25.9954L98.5601 21.6654V26.3421C98.5601 26.4403 98.4803 26.5201 98.3821 26.5201C98.2838 26.5201 98.2041 26.4403 98.2041 26.3421V21.6646L96.4204 25.9954C96.392 26.0636 96.3254 26.1048 96.2559 26.1051C96.2333 26.105 96.2108 26.1007 96.1882 26.0923C96.0971 26.0553 96.0544 25.9513 96.0914 25.8602L97.875 21.5296L94.5798 24.844C94.5456 24.8796 94.4986 24.8967 94.453 24.8967V24.8952C94.4074 24.8952 94.3619 24.8781 94.3277 24.844C94.2579 24.7742 94.2579 24.6617 94.3277 24.5919L97.6284 21.2721L93.3173 23.0682C93.2945 23.0782 93.2717 23.0825 93.249 23.0825C93.1792 23.0825 93.1137 23.0412 93.0852 22.9728C93.0467 22.8817 93.0909 22.7777 93.1806 22.7407L97.4936 20.9437H92.8245C92.7262 20.9437 92.6465 20.864 92.6465 20.7657C92.6465 20.6675 92.7262 20.5877 92.8245 20.5877H97.4935L93.1808 18.7909C93.0897 18.7524 93.0469 18.6485 93.0854 18.5588C93.1224 18.4676 93.2278 18.4249 93.3175 18.4633L97.6292 20.2598L94.3272 16.9386C94.2574 16.8688 94.2588 16.7563 94.3272 16.6866C94.3969 16.6168 94.5094 16.6182 94.5792 16.6866L97.8748 20.0012L96.0914 15.6712C96.0544 15.5801 96.0971 15.4761 96.1882 15.4391C96.2794 15.4021 96.3833 15.4448 96.4204 15.5359L98.2041 19.8668V15.178C98.2041 15.0797 98.2838 15 98.3821 15C98.4803 15 98.5601 15.0797 98.5601 15.178Z'
          fill={color}
        />
      </g>
      <g clipPath='url(#clip0_847_567)'>
        <path
          d='M34.3423 26.1895L24.602 41.5047C23.7552 42.8361 24.7117 44.578 26.2896 44.578H43.8491L44.0016 26.1895H34.3423Z'
          fill={flapColor}
        />
        <path
          d='M98.5855 91.0623C98.8111 92.2909 97.8676 93.4234 96.6184 93.4234H46.6818L34.3428 26.1895H86.6761L98.5855 91.0623Z'
          fill={color}
        />
        <path
          d='M76.4609 65.9049H58.911L54.0127 39.1836H71.5626L76.4609 65.9049Z'
          fill='#FFFFFF'
        />
        <path
          d='M67.4949 43.0181H59.7835C59.5509 43.0181 59.3604 42.8275 59.3604 42.595C59.3604 42.3625 59.5509 42.1719 59.7835 42.1719H67.4949C67.7274 42.1719 67.918 42.3625 67.918 42.595C67.918 42.8275 67.7274 43.0181 67.4949 43.0181Z'
          fill={labelColor}
        />
        <path
          d='M24.4006 93.4234C23.1514 93.4234 22.2079 92.291 22.4335 91.0623L34.3429 26.1895L46.6819 93.4234H24.4006Z'
          fill={panelColor}
        />
      </g>
      <g clipPath='url(#clip1_847_567)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.9179 103.728C21.941 103.736 21.9642 103.739 21.9856 103.739V103.738C22.0715 103.738 22.1507 103.685 22.1804 103.599L23.4251 99.9804C23.4614 99.8731 23.4036 99.7542 23.2963 99.7179C23.189 99.6816 23.0702 99.7393 23.0339 99.8466L21.7892 103.465C21.7529 103.572 21.8106 103.691 21.9179 103.728ZM19.8999 103.741C19.9346 103.814 20.0089 103.857 20.0848 103.857C20.1162 103.857 20.1459 103.85 20.1756 103.835C20.278 103.786 20.3192 103.662 20.2697 103.559L18.5909 100.121C18.5413 100.019 18.4175 99.9772 18.3152 100.027C18.2128 100.076 18.1716 100.2 18.2211 100.302L19.8999 103.741ZM18.8258 105.283C18.8043 105.283 18.7812 105.28 18.7581 105.272L15.1396 104.027C15.0323 103.991 14.9745 103.872 15.0109 103.765C15.0472 103.657 15.166 103.6 15.2733 103.636L18.8918 104.881C18.9991 104.917 19.0569 105.036 19.0206 105.143C18.9909 105.229 18.9116 105.282 18.8258 105.282V105.283ZM15.3197 108.747C15.3544 108.819 15.4287 108.862 15.5046 108.862C15.536 108.862 15.5657 108.856 15.5954 108.841L19.034 107.162C19.1363 107.112 19.1776 106.989 19.1281 106.886C19.0785 106.785 18.9547 106.743 18.8524 106.792L15.4138 108.471C15.3115 108.52 15.2702 108.644 15.3197 108.747ZM19.1243 112.061C19.1028 112.061 19.0797 112.058 19.0566 112.05C18.9493 112.014 18.8915 111.895 18.9278 111.787L20.1725 108.169C20.2089 108.062 20.3277 108.004 20.435 108.04C20.5423 108.076 20.6001 108.195 20.5638 108.303L19.3191 111.921C19.2894 112.007 19.2101 112.06 19.1243 112.06V112.061ZM23.7613 111.647C23.7959 111.72 23.8702 111.763 23.9462 111.763C23.9775 111.763 24.0072 111.756 24.0369 111.741C24.1393 111.692 24.1806 111.568 24.131 111.466L22.4522 108.027C22.4027 107.925 22.2789 107.883 22.1765 107.933C22.0742 107.983 22.0329 108.106 22.0824 108.209L23.7613 111.647ZM27.1471 108.143C27.1256 108.143 27.1026 108.139 27.0794 108.131L23.4609 106.886C23.3536 106.85 23.2958 106.731 23.3321 106.624C23.3685 106.517 23.4873 106.459 23.5946 106.495L27.2131 107.74C27.3204 107.776 27.3782 107.895 27.3419 108.002C27.3122 108.088 27.2329 108.141 27.1471 108.141V108.143ZM23.227 104.884C23.2616 104.956 23.3359 104.999 23.4118 104.999C23.4432 104.999 23.4729 104.993 23.5026 104.978L26.9412 103.299C27.0436 103.249 27.0848 103.126 27.0353 103.023C26.9858 102.921 26.862 102.88 26.7596 102.929L23.321 104.608C23.2187 104.657 23.1774 104.781 23.227 104.884Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_847_567'>
          <rect
            width='77'
            height='67.4703'
            fill='white'
            transform='translate(22 26)'
          />
        </clipPath>
        <clipPath id='clip1_847_567'>
          <rect
            width='14.1176'
            height='14.1176'
            fill='white'
            transform='translate(14.1172 98.8242)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const TagDollarSign = () => (
  <path
    d='M57.6573 54.4794L57.916 53.1485C58.5669 49.8 56.3801 46.5579 53.0316 45.907V45.907M42.9444 65.4314L42.5707 67.3538C41.9198 70.7023 44.1066 73.9444 47.4551 74.5953V74.5953M53.0316 45.907L52.6151 45.826C49.4966 45.2199 46.4772 47.2565 45.871 50.375V50.375C45.5799 51.8726 45.8956 53.4244 46.7487 54.6892L53.7543 65.0753C54.6706 66.4337 55.0096 68.1011 54.6969 69.7096V69.7096C54.046 73.0581 50.8036 75.2462 47.4551 74.5953V74.5953M53.0316 45.907L53.8364 41.7664M47.4551 74.5953L46.6503 78.7359'
    stroke='white'
    strokeWidth='1.54412'
    strokeMiterlimit='10'
    strokeLinecap='round'
  />
)
const StickerDollarSign = () => (
  <path
    xmlns='http://www.w3.org/2000/svg'
    d='M66.3529 52.7504V51.3945C66.3529 47.9834 63.5876 45.2181 60.1765 45.2181V45.2181M54 66.3085V68.2669C54 71.678 56.7653 74.4433 60.1765 74.4433V74.4433M60.1765 45.2181H59.7522C56.5754 45.2181 54 47.7934 54 50.9703V50.9703C54 52.4959 54.606 53.959 55.6848 55.0377L64.5434 63.8963C65.702 65.055 66.3529 66.627 66.3529 68.2656V68.2656C66.3529 71.6767 63.5876 74.4433 60.1765 74.4433V74.4433M60.1765 45.2181V41M60.1765 74.4433V78.6614'
    stroke='white'
    strokeWidth='1.54412'
    strokeMiterlimit='10'
    strokeLinecap='round'
  />
)
const TagPercentSign = () => (
  <>
    <path
      d='M63.0668 46.9539L38.0473 73.9341'
      stroke='white'
      strokeWidth='1.54412'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M51.115 76.7296C53.2051 77.1359 55.2344 75.7417 55.6477 73.6157C56.061 71.4896 54.7016 69.4368 52.6116 69.0305C50.5215 68.6243 48.4921 70.0184 48.0789 72.1445C47.6656 74.2705 49.0249 76.3233 51.115 76.7296Z'
      stroke='white'
      strokeWidth='1.54412'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M48.5037 51.8546C50.5938 52.2609 52.6231 50.8667 53.0364 48.7407C53.4496 46.6146 52.0903 44.5618 50.0002 44.1555C47.9102 43.7493 45.8808 45.1434 45.4675 47.2695C45.0543 49.3955 46.4136 51.4483 48.5037 51.8546Z'
      stroke='white'
      strokeWidth='1.54412'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </>
)
const StickerPercentSign = () => (
  <>
    <path
      d='M69.7057 44.3711L50.2939 75.6295'
      stroke='white'
      strokeWidth='1.54412'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M63.655 75.8822C65.7842 75.8822 67.5103 74.1265 67.5103 71.9606C67.5103 69.7948 65.7842 68.0391 63.655 68.0391C61.5259 68.0391 59.7998 69.7948 59.7998 71.9606C59.7998 74.1265 61.5259 75.8822 63.655 75.8822Z'
      stroke='white'
      strokeWidth='1.54412'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M56.3455 51.9604C58.4747 51.9604 60.2007 50.2046 60.2007 48.0388C60.2007 45.8729 58.4747 44.1172 56.3455 44.1172C54.2163 44.1172 52.4902 45.8729 52.4902 48.0388C52.4902 50.2046 54.2163 51.9604 56.3455 51.9604Z'
      stroke='white'
      strokeWidth='1.54412'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </>
)

export const TagIcon = ({
  color,
  altText
}: {
  color: string
  altText: string
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='13'
    height='12'
    viewBox='0 0 13 12'
    fill='none'
  >
    <title>{altText}</title>
    <path
      d='M5.06072 10.7123L1.78821 7.43984C1.58536 7.20736 1.48263 6.90412 1.50241 6.59621C1.52218 6.28831 1.66287 6.0007 1.89379 5.79608L6.29492 1.39495C6.42051 1.26604 6.57136 1.16446 6.73803 1.09657C6.9047 1.02868 7.0836 0.995939 7.26351 1.0004L10.396 1.14099C10.6497 1.14692 10.8914 1.25033 11.071 1.42975C11.2505 1.60917 11.354 1.85083 11.3601 2.10458L11.4996 5.23705C11.5041 5.41696 11.4713 5.59586 11.4034 5.76253C11.3355 5.92919 11.234 6.08005 11.1051 6.20563L6.70392 10.6068C6.49931 10.8375 6.21182 10.9781 5.90406 10.9979C5.59629 11.0177 5.29317 10.915 5.06072 10.7123Z'
      stroke={color}
      strokeWidth='1.09375'
      strokeMiterlimit='10'
    />
  </svg>
)

export const RewardIcon = ({
  color,
  altText
}: {
  color: string
  altText: string
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
  >
    <title>{altText}</title>
    <g opacity='0.65' clipPath='url(#clip0_1161_2422)'>
      <path
        d='M12.893 4.66016H1.10234C0.806354 4.66016 0.566406 4.9001 0.566406 5.19609V7.33984C0.566406 7.63583 0.806354 7.87578 1.10234 7.87578H12.893C13.189 7.87578 13.4289 7.63583 13.4289 7.33984V5.19609C13.4289 4.9001 13.189 4.66016 12.893 4.66016Z'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.3574 7.875V12.6984C12.3574 12.8406 12.301 12.9769 12.2004 13.0774C12.0999 13.1779 11.9636 13.2344 11.8215 13.2344H2.17461C2.03247 13.2344 1.89615 13.1779 1.79564 13.0774C1.69514 12.9769 1.63867 12.8406 1.63867 12.6984V7.875'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.99805 4.66016V13.2352'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.2666 1.3914C10.8923 2.01711 10.9291 3.07022 10.2666 3.65708C9.13376 4.65995 6.99805 4.65995 6.99805 4.65995C6.99805 4.65995 6.99805 2.52424 8.00293 1.3914C8.58777 0.728847 9.64089 0.765692 10.2666 1.3914Z'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.72929 1.3914C3.10358 2.01711 3.06674 3.07022 3.72929 3.65708C4.86213 4.65995 6.99784 4.65995 6.99784 4.65995C6.99784 4.65995 6.99784 2.52424 5.99296 1.3914C5.40811 0.728847 4.355 0.765692 3.72929 1.3914Z'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_1161_2422'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const LoyaltyIcon = ({ color }: { color: string }) => {
  return (
    <svg
      width='120'
      height='121'
      viewBox='0 0 120 121'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2348_307)'>
        <rect
          x='23.9355'
          y='26.2461'
          width='67.0588'
          height='75'
          rx='6.39706'
          transform='rotate(-4 23.9355 26.2461)'
          fill={color}
        />
        <path
          d='M62.6152 98.7246L57.3835 23.9073'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='square'
          strokeLinejoin='round'
        />
        <path
          d='M27.4619 64.0332L92.3769 59.4939'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='square'
          strokeLinejoin='round'
        />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.7418 47.8893C47.9516 44.2628 53.3859 44.8478 54.7732 48.8615L58.2673 58.9706C58.4899 59.6145 57.8359 60.2131 57.2141 59.9346L48.2346 55.9129C45.1572 54.5346 43.9873 50.7688 45.7418 47.8893ZM56.2326 48.3571C54.4185 43.1088 47.3127 42.3438 44.4232 47.0859C42.1848 50.7594 43.6774 55.5637 47.6034 57.3221L56.583 61.3439C56.6552 61.3762 56.7275 61.4046 56.7999 61.4292L58.1001 62.008C54.1377 67.3687 52.1935 73.9872 52.6619 80.6852L52.6742 80.8612C52.704 81.2865 53.0729 81.6072 53.4982 81.5775C53.9236 81.5477 54.2443 81.1788 54.2146 80.7534L54.2023 80.5775C53.7516 74.1328 55.6642 67.766 59.5468 62.6522L59.7183 62.7285C59.4259 68.0408 60.88 73.3576 63.8254 77.8015C64.061 78.157 64.5401 78.2541 64.8955 78.0185C65.2509 77.783 65.3481 77.3039 65.1125 76.9485C62.3036 72.7105 60.9417 67.6266 61.2749 62.568L64.4525 60.9489L71.2635 57.629C75.1737 55.7231 76.378 50.734 73.7936 47.1474C70.5555 42.6534 63.6224 43.8243 62.2101 49.1037L59.7149 58.4319L56.2326 48.3571ZM72.5466 48.0347C70.0742 44.6034 64.7806 45.4974 63.7023 49.5284L61.0557 59.4223C60.8829 60.0683 61.5591 60.629 62.1586 60.3368L70.5663 56.2386C73.6267 54.7468 74.5693 50.8419 72.5466 48.0347Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M106.517 13.1454C106.537 13.1525 106.557 13.1553 106.575 13.1553V13.1539C106.649 13.1539 106.717 13.1086 106.742 13.0351L107.809 9.9335C107.84 9.84153 107.791 9.73965 107.699 9.70852C107.607 9.6774 107.505 9.72692 107.474 9.81889L106.407 12.9205C106.376 13.0124 106.425 13.1143 106.517 13.1454ZM104.788 13.1567C104.818 13.219 104.882 13.2557 104.947 13.2557C104.974 13.2557 104.999 13.2501 105.024 13.2373C105.112 13.1949 105.148 13.0888 105.105 13.0011L103.666 10.0537C103.624 9.96598 103.518 9.93061 103.43 9.97306C103.342 10.0155 103.307 10.1216 103.349 10.2093L104.788 13.1567ZM103.867 14.4781C103.849 14.4781 103.829 14.4753 103.809 14.4682L100.708 13.4014C100.616 13.3702 100.566 13.2684 100.597 13.1764C100.628 13.0844 100.73 13.0349 100.822 13.066L103.924 14.1329C104.016 14.164 104.065 14.2659 104.034 14.3579C104.009 14.4315 103.941 14.4767 103.867 14.4767V14.4781ZM100.862 17.4467C100.892 17.509 100.955 17.5458 101.02 17.5458C101.047 17.5458 101.073 17.5401 101.098 17.5274L104.046 16.0884C104.133 16.0459 104.169 15.9398 104.126 15.8521C104.084 15.7658 103.978 15.729 103.89 15.7714L100.943 17.2104C100.855 17.2529 100.819 17.359 100.862 17.4467ZM104.123 20.2881C104.105 20.2881 104.085 20.2853 104.065 20.2782C103.973 20.2471 103.924 20.1452 103.955 20.0532L105.022 16.9517C105.053 16.8597 105.155 16.8102 105.246 16.8413C105.338 16.8724 105.388 16.9743 105.357 17.0663L104.29 20.1679C104.265 20.2414 104.197 20.2867 104.123 20.2867V20.2881ZM108.098 19.9339C108.127 19.9962 108.191 20.0329 108.256 20.0329C108.283 20.0329 108.308 20.0273 108.334 20.0146C108.422 19.9721 108.457 19.866 108.415 19.7783L106.976 16.8309C106.933 16.7432 106.827 16.7079 106.739 16.7503C106.651 16.7928 106.616 16.8989 106.659 16.9866L108.098 19.9339ZM111 16.9312C110.982 16.9312 110.962 16.9283 110.942 16.9212L107.84 15.8544C107.748 15.8232 107.699 15.7214 107.73 15.6294C107.761 15.5374 107.863 15.4879 107.955 15.519L111.057 16.5859C111.149 16.617 111.198 16.7189 111.167 16.8109C111.141 16.8845 111.074 16.9297 111 16.9297V16.9312ZM107.639 14.1365C107.669 14.1988 107.732 14.2356 107.798 14.2356C107.824 14.2356 107.85 14.2299 107.875 14.2172L110.823 12.7782C110.91 12.7357 110.946 12.6296 110.903 12.5419C110.861 12.4542 110.755 12.4188 110.667 12.4612L107.72 13.9002C107.632 13.9427 107.597 14.0488 107.639 14.1365Z'
        fill={color}
      />
      <g opacity='0.33'>
        <path
          d='M12.0387 100.483C12.0365 100.307 12.2658 100.237 12.3626 100.384L13.7408 102.481C13.7706 102.526 13.8197 102.555 13.8738 102.56L16.1691 102.75C16.3281 102.763 16.3894 102.963 16.2649 103.063L14.4681 104.504C14.4257 104.538 14.4013 104.589 14.402 104.644L14.432 107.153C14.4341 107.329 14.2049 107.399 14.1081 107.252L12.7298 105.155C12.7 105.11 12.651 105.08 12.5969 105.076L10.3016 104.886C10.1426 104.873 10.0812 104.673 10.2057 104.573L12.0026 103.132C12.0449 103.098 12.0693 103.047 12.0687 102.992L12.0387 100.483Z'
          fill={color}
        />
        <path
          d='M19.5421 107.394C19.5404 107.25 19.7267 107.193 19.8053 107.313L20.9252 109.017C20.9494 109.054 20.9892 109.077 21.0332 109.081L22.8981 109.235C23.0273 109.246 23.0771 109.409 22.976 109.49L21.516 110.66C21.4816 110.688 21.4618 110.73 21.4624 110.774L21.4867 112.813C21.4885 112.956 21.3022 113.013 21.2236 112.893L20.1037 111.189C20.0795 111.153 20.0397 111.129 19.9957 111.125L18.1308 110.971C18.0016 110.961 17.9518 110.798 18.0529 110.716L19.5128 109.546C19.5473 109.518 19.5671 109.476 19.5665 109.432L19.5421 107.394Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_2348_307'>
          <rect
            x='23.9355'
            y='26.2461'
            width='67.0588'
            height='75'
            rx='6.39706'
            transform='rotate(-4 23.9355 26.2461)'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LoyaltyDiamondIcon = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='76'
      height='76'
      viewBox='0 0 76 76'
      fill='none'
    >
      <path
        d='M58.2012 25.0996L39.6341 21.967L21.0673 18.8328L9.79 29.9542L32.3111 63.5558L65.0245 39.2765L58.2012 25.0996Z'
        fill={color}
      />
      <mask
        id='mask0_2450_3'
        maskUnits='userSpaceOnUse'
        x='9'
        y='18'
        width='57'
        height='46'
      >
        <path
          d='M58.2178 25.1026L39.6507 21.97L21.0839 18.8357L9.80661 29.9571L32.3277 63.5587L65.0411 39.2795L58.2178 25.1026Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_2450_3)'>
        <path
          d='M6.80751 29.4532L68.0419 39.7859'
          stroke='white'
          strokeWidth='0.586624'
          strokeMiterlimit='10'
        />
        <path
          d='M32.0673 65.0536L40.0522 19.7012'
          stroke='white'
          strokeWidth='0.586624'
          strokeMiterlimit='10'
        />
        <path
          d='M49.3786 21.7951L52.5855 37.1776L32.3287 63.5596'
          stroke='white'
          strokeWidth='0.586624'
          strokeMiterlimit='10'
        />
        <path
          d='M30.5471 18.6173L22.2642 32.0605L32.3287 63.5593'
          stroke='white'
          strokeWidth='0.586624'
          strokeMiterlimit='10'
        />
      </g>
      <g opacity='0.33'>
        <path
          d='M71.3044 8.14276C71.3057 8.03128 71.1608 7.98697 71.0995 8.08013L70.228 9.40616C70.2091 9.43484 70.1781 9.45326 70.1439 9.45608L68.6925 9.57598C68.5919 9.58429 68.5532 9.71115 68.6319 9.77426L69.7681 10.6853C69.7949 10.7068 69.8103 10.7394 69.8099 10.7737L69.7909 12.3604C69.7896 12.4719 69.9345 12.5162 69.9958 12.423L70.8673 11.097C70.8861 11.0683 70.9172 11.0499 70.9514 11.0471L72.4028 10.9272C72.5034 10.9188 72.5421 10.792 72.4634 10.7289L71.3272 9.81784C71.3004 9.79636 71.285 9.76376 71.2854 9.72944L71.3044 8.14276Z'
          fill={color}
        />
        <path
          d='M66.5595 12.5126C66.5606 12.422 66.4428 12.386 66.3931 12.4617L65.685 13.5391C65.6697 13.5624 65.6445 13.5774 65.6167 13.5797L64.4374 13.6771C64.3557 13.6838 64.3242 13.7869 64.3881 13.8382L65.3113 14.5784C65.3331 14.5959 65.3456 14.6224 65.3453 14.6502L65.3299 15.9394C65.3288 16.03 65.4465 16.066 65.4963 15.9903L66.2044 14.9129C66.2197 14.8896 66.2449 14.8746 66.2727 14.8723L67.452 14.7749C67.5337 14.7682 67.5652 14.6651 67.5013 14.6138L66.5781 13.8736C66.5563 13.8562 66.5438 13.8297 66.5441 13.8018L66.5595 12.5126Z'
          fill={color}
        />
      </g>
      <g clipPath='url(#clip0_2450_3)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.9186 65.6513C13.9333 65.6565 13.9479 65.6586 13.9614 65.6586V65.6576C14.0157 65.6576 14.0658 65.6242 14.0846 65.5699L14.8717 63.2817C14.8947 63.2139 14.8581 63.1387 14.7903 63.1158C14.7224 63.0928 14.6473 63.1293 14.6243 63.1972L13.8372 65.4853C13.8143 65.5532 13.8508 65.6284 13.9186 65.6513ZM12.6426 65.6598C12.6645 65.7057 12.7114 65.7329 12.7595 65.7329C12.7793 65.7329 12.7981 65.7287 12.8169 65.7193C12.8816 65.688 12.9077 65.6097 12.8764 65.545L11.8148 63.3706C11.7834 63.3059 11.7052 63.2798 11.6404 63.3111C11.5757 63.3424 11.5496 63.4207 11.5809 63.4854L12.6426 65.6598ZM11.9633 66.6351C11.9498 66.6351 11.9351 66.633 11.9205 66.6278L9.63236 65.8407C9.5645 65.8177 9.52797 65.7426 9.55093 65.6747C9.5739 65.6069 9.64906 65.5703 9.71691 65.5933L12.0051 66.3804C12.0729 66.4033 12.1095 66.4785 12.0865 66.5463C12.0677 66.6006 12.0176 66.634 11.9633 66.634V66.6351ZM9.74625 68.8251C9.76817 68.871 9.81515 68.8982 9.86316 68.8982C9.883 68.8982 9.90179 68.894 9.92058 68.8846L12.095 67.823C12.1597 67.7917 12.1858 67.7134 12.1545 67.6487C12.1231 67.585 12.0449 67.5578 11.9801 67.5892L9.80575 68.6508C9.74103 68.6821 9.71494 68.7604 9.74625 68.8251ZM12.1521 70.9212C12.1385 70.9212 12.1239 70.9191 12.1093 70.9139C12.0414 70.891 12.0049 70.8158 12.0279 70.7479L12.8149 68.4598C12.8379 68.3919 12.9131 68.3554 12.9809 68.3784C13.0488 68.4013 13.0853 68.4765 13.0623 68.5443L12.2753 70.8325C12.2565 70.8868 12.2064 70.9202 12.1521 70.9202V70.9212ZM15.0843 70.6593C15.1062 70.7052 15.1532 70.7324 15.2012 70.7324C15.221 70.7324 15.2398 70.7282 15.2586 70.7188C15.3233 70.6875 15.3494 70.6092 15.3181 70.5445L14.2565 68.3701C14.2252 68.3054 14.1469 68.2793 14.0822 68.3106C14.0174 68.3419 13.9913 68.4202 14.0227 68.4849L15.0843 70.6593ZM17.2253 68.4432C17.2117 68.4432 17.1972 68.4411 17.1825 68.4359L14.8943 67.6488C14.8265 67.6259 14.79 67.5507 14.8129 67.4829C14.8359 67.415 14.911 67.3785 14.9789 67.4014L17.2671 68.1885C17.3349 68.2115 17.3714 68.2866 17.3485 68.3545C17.3297 68.4088 17.2796 68.4422 17.2253 68.4422V68.4432ZM14.7464 66.3823C14.7683 66.4283 14.8153 66.4554 14.8633 66.4554C14.8832 66.4554 14.9019 66.4512 14.9207 66.4418L17.0951 65.3802C17.1599 65.3489 17.1859 65.2706 17.1546 65.2059C17.1233 65.1412 17.045 65.1151 16.9803 65.1464L14.8059 66.208C14.7412 66.2393 14.7151 66.3176 14.7464 66.3823Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_2450_3'>
          <rect
            width='8.92734'
            height='8.92734'
            fill='white'
            transform='translate(8.98584 62.5506)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const SmallRightArrow = ({ color }: { color?: string }) => {
  return (
    <svg
      width='11'
      height='8'
      viewBox='0 0 11 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 3.875H1M10 3.875L7.208 0.875M10 3.875L7.208 6.875'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
